import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import UnevoHome from "@/pages/UnevoHome";
import UnnatiAi from "@/pages/UnnatiAi";
import ServiceDetail from "@/pages/ServiceDetail";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UnevoHome />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        <Route path="/unnati-ai" element={<UnnatiAi />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="*" element={<UnevoHome />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
